import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ugrr_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function getToken() {
  return localStorage.getItem("ugrr_token");
}

// Image URL with token as query param (img tags can't send headers)
export function weekImageUrl(weekId) {
  const token = getToken();
  return `${API}/weeks/${weekId}/image?auth=${encodeURIComponent(token || "")}`;
}

export function pageImageUrl(pageId) {
  const token = getToken();
  return `${API}/pages/${pageId}/image?auth=${encodeURIComponent(token || "")}`;
}
